import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { Subscription } from "rxjs";

@Component({
  selector: "app-fullscreen-image-popup",
  templateUrl: "./fullscreen-image-popup.component.html",
  styleUrls: ["./fullscreen-image-popup.component.scss"],
})
export class FullscreenImagePopupComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() image_path: any;
  @Input() lottieOptions: any;
  @Input() claimAnimationHost: HTMLElement;
  @Input() claimMessage: string;
  @Input() claimCouponName: string;
  @Input() claimCloseLabel: string;
  @Input() claimCloseAction: () => void;
  @ViewChild("claimCanvas") claimCanvas: ElementRef<HTMLElement>;

  private animationLoginInstance: any;
  private unsubscribeBackEvent: Subscription;

  constructor(
    private modalController: ModalController,
    private platform: Platform
  ) {}

  closeModal() {
    if (this.claimAnimationHost) {
      this.claimCloseAction();
      return;
    }
    this.modalController.dismiss();
  }

  ngAfterViewInit() {
    if (this.claimAnimationHost && this.claimCanvas) {
      this.claimCanvas.nativeElement.appendChild(this.claimAnimationHost);
    }
  }

  animationCreated(ev) {
    this.animationLoginInstance = ev;
    this.animationLoginInstance.setSpeed(0.8);
  }

  ngOnInit() {
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      200,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
  }
}
